var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { RadioGroup as HeadlessRadioGroup } from '@headlessui/react';
import clsx from 'clsx';
import { runIfFn } from '../utils/index.js';
import { Radio } from './Radio.js';
import { RadioGroupsProvider, useRadioGroups, } from './RadioGroupContext.js';
export const RadioGroup = (_a) => {
    var { children, variant = 'list' } = _a, rest = __rest(_a, ["children", "variant"]);
    return (React.createElement(HeadlessRadioGroup, Object.assign({}, rest),
        React.createElement("div", { className: "relative isolate" },
            React.createElement(RadioGroupsProvider, { variant: variant }, children))));
};
const RadioGroupItems = props => {
    const { children, className } = props, rest = __rest(props, ["children", "className"]);
    const { variant } = useRadioGroups();
    const variantClsx = [
        variant === 'list' && 'rounded-md -space-y-px',
        variant === 'stacked-cards' && 'space-y-4',
    ];
    return (React.createElement("div", Object.assign({ className: clsx(variantClsx, className) }, rest), children));
};
const RadioGroupItem = props => {
    const { variant } = useRadioGroups();
    switch (variant) {
        case 'list':
        default:
            return React.createElement(RadioGroupItemList, Object.assign({}, props));
        case 'stacked-cards':
            return React.createElement(RadioGroupItemCard, Object.assign({}, props));
    }
};
const RadioGroupItemList = props => {
    const { value, title, description, children, disabled, className } = props, rest = __rest(props, ["value", "title", "description", "children", "disabled", "className"]);
    return (React.createElement(HeadlessRadioGroup.Option, Object.assign({ as: "label", className: renderProps => clsx(renderProps.checked
            ? 'bg-action-primary-subdued text-content-primary border-focused z-10'
            : 'bg-surface border-line', 'relative border p-4 flex', 'focus:outline-none  focus-visible:ring', 'first:rounded-ts-md first:rounded-te-md', 'last:rounded-bs-md last:rounded-be-md', !renderProps.disabled && ' cursor-pointer', renderProps.disabled && 'opacity-60 cursor-default', className), value: value, disabled: disabled }, rest), renderProps => (React.createElement(Radio, { active: renderProps.active, checked: renderProps.checked, disabled: renderProps.disabled }, title ? (React.createElement(React.Fragment, null,
        React.createElement(HeadlessRadioGroup.Label, { as: "span", className: clsx(renderProps.checked ? 'text-content-primary' : 'text-content', 'block text-sm font-medium') }, title),
        description && (React.createElement(HeadlessRadioGroup.Description, { as: "span", className: clsx(renderProps.checked
                ? 'text-content-primary'
                : 'text-content-subdued', 'block text-sm') }, description)))) : (runIfFn(children, renderProps))))));
};
const RadioGroupItemCard = props => {
    const { value, children, disabled, className } = props, rest = __rest(props, ["value", "children", "disabled", "className"]);
    return (React.createElement(HeadlessRadioGroup.Option, Object.assign({ as: "label", className: renderProps => clsx(renderProps.active ? 'ring-1 ring-focused' : '', 'relative block rounded-lg border border-line shadow-sm px-6 py-4 sm:flex sm:justify-between', ' bg-surface text-content-subdued', 'focus:outline-none focus-visible:ring', !renderProps.disabled && 'cursor-pointer hover:border-line', renderProps.disabled && 'opacity-60 cursor-default', className), value: value, disabled: disabled }, rest), renderProps => runIfFn(children, renderProps)));
};
RadioGroup.Items = RadioGroupItems;
RadioGroup.Item = RadioGroupItem;
//# sourceMappingURL=RadioGroup.js.map